<div mat-dialog-title>
    Update Kit Status
</div>
<mat-dialog-content>
    <div class="mat-body-1">
        <div>
            <span class="label">Email:</span>
            <span class="value">{{kit.email}}</span>
        </div>
        <div>
            <span class="label">Code:</span>
             <span class="value">{{kit.code}}</span>
        </div>
        <div class="label">Status:</div>
        <mat-radio-group [value]="kit.status" (change)="statusChanged($event)">
            <mat-radio-button value="registered">Registered</mat-radio-button>
            <mat-radio-button value="scheduled">Scheduled</mat-radio-button>
            <mat-radio-button value="assigned_to_lab">Assigned To Lab</mat-radio-button>
            <mat-radio-button value="en_route_to_lab">En Route To Lab</mat-radio-button>
            <mat-radio-button value="at_lab">At Lab</mat-radio-button>
            <mat-radio-button value="tested">Tested</mat-radio-button>
            <mat-radio-button value="notified">Notified</mat-radio-button>
            <mat-radio-button value="test_not_performed">Test Not Performed</mat-radio-button>
        </mat-radio-group>

        <mat-checkbox [(ngModel)]="sendEmail">Send notification email</mat-checkbox>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button
            color="primary"
            type="button"
            [disabled]="!newStatus"
            (click)="update()">Update</button>
    <button mat-raised-button
            mat-dialog-close
            type="button">Cancel</button>
</mat-dialog-actions>

